import React, { useEffect, useRef, useState } from 'react'
import { globalStyles } from '../../static/styles/global'
import HomeDetailsHeader from '../home/HomeDetailsHeader'
import { Dimensions, ScrollView, View, ActivityIndicator, Text } from 'react-native'
import { usePersonalStore } from '../../stores/personalInfo'
import ModalPopup from '../shared/modal/ModalPopup'
import AsyncStorage from '@react-native-async-storage/async-storage'
import CustomButton from '../shared/button/Button'
import { useTranslation } from 'react-i18next'
import { useHomeStore } from '../../stores/home'
import { labourService } from '../../services/labourService'
import { useLabourStore } from '../../stores/labour'
import moment from 'moment'


const CanarayForm = ({ navigation, route }: any) => {


    const { params } = route
    const {
        userkey
    } = params
    const screenHeight = Dimensions.get('window').height;

    const iframeRef = useRef(null);
    const personalstore = usePersonalStore()
    const homestore = useHomeStore()
    const labourstore = useLabourStore()
    const { t } = useTranslation()
    const item = homestore?.companyData?.data?.[0] || {};
    const { client_id, company_name, entity_id } = item;

    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(true)

    const getSelectedLanguage = async () => {

        const language = await AsyncStorage.getItem('selectedLanguage');
        if (language === 'SPA') {
            return 'es'
        }
        else {
            return 'en'
        }
    }



    async function sendDataToIframe() {
        let userData
        // if (personalstore?.personalData?.hasCanary == 2) {
        //     userData =
        //     {
        //         user_key: userkey?.toString(),
        //         lan: await getSelectedLanguage(),
        //         company_name: company_name,
        //         entity_id: entity_id?.toString(),
        //         client_id: client_id?.toString()
        //     };

        // }
        // else {
        const completeName = [
            personalstore?.personalData?.firstName,
            personalstore?.personalData?.middleInitial,
            personalstore?.personalData?.lastName,
        ]
            .map(name => name?.trim())
            .filter(name => name)
            .join(" ");

        const address = [
            personalstore?.personalData?.addressLine1,
            personalstore?.personalData?.addressLine2,
        ]
            .map(v => v?.trim())
            .filter(Boolean)
            .join(", ");

        userData = {
            client_id: client_id,
            entity_id: entity_id?.toString(),
            user_key: userkey?.toString(),
            company_name: company_name,
            legal_name: completeName,
            email_address: personalstore?.personalData?.employeeEmailAddress,
            phone_number: personalstore?.personalData?.mainPhoneNumber,
            dob: moment(personalstore?.personalData?.dateOfBirth).format("YYYY-MM-DD"),
            address: address,
            city: personalstore?.personalData?.city || '',
            state: personalstore?.personalData?.stateValue || '',
            zipcode: personalstore?.personalData?.zip,
            employee_id: labourstore?.labourData?.employeeNumber ? labourstore?.labourData?.employeeNumber?.toString() : "",
            ess_id: '',
            lan: await getSelectedLanguage()
        };

        // }
        try {
            const iframe: any = iframeRef.current
            if (!iframe || !iframe.contentWindow) {

                return;
            }
            console.log('Sending data to iframe:', userData);
            setTimeout(() => {
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage(userData, 'https://wotclite.canaryai.com');
                }
                console.log('Data sent to iframe');
            }, 1000);


        } catch (error) {
            console.error('Error sending data to iframe:', error);
        }
    }






    function handleIframeSubmit(data: any) {
        console.log("📥 Parent received data from iframe:", data);
        setDisabled(false)
    }



    useEffect(() => {

        const handleMessage = (event: any) => {


            if (event.data?.type === "WOTC_FORM_SUBMITTED") {
                handleIframeSubmit(event.data.payload);
            }

        }
        window.addEventListener("message", handleMessage)


        return () => window.removeEventListener('message', handleMessage)

    }, [])





    if (personalstore?.loading || homestore?.loading)
        return <ActivityIndicator size="large" />
    return (
        <>
            <ScrollView style={{ flex: 1 }} >
                <View style={[globalStyles.horizontalPadGap, globalStyles.primaryBgColor, { padding: 20 }]}>
                    <HomeDetailsHeader />
                </View>
                <View style={[{
                    marginTop: -44,
                    padding: 20,
                    flex: 1
                }]}>


                    <iframe
                        id="wotc_bot_iframe"
                        src="https://wotclite.canaryai.com/fms"
                        width="100%"
                        height={screenHeight - 100}
                        style={{ border: "none" }}
                        ref={iframeRef}
                        onLoad={sendDataToIframe} />

                </View>



                <ModalPopup visible={loading} >
                    <ActivityIndicator size='large' />
                </ModalPopup>

            </ScrollView >
            <View style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: 15, marginTop: 15, paddingHorizontal: 20 }}>
                <CustomButton
                    text={t("Continue Onboarding")}
                    onPress={() => navigation.navigate("Onboarding")}
                    isDisabled={disabled} />
            </View>
        </>
    )
}

export default CanarayForm
